import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MapService } from 'src/app/services/map.service';

@Component({
  selector: 'app-menu-bottom',
  templateUrl: './menu-bottom.component.html',
  styleUrls: ['./menu-bottom.component.scss'],
})
export class MenuBottomComponent implements OnInit {
  @Output() showMenu = new EventEmitter<string>();
  @Output() timeRange = new EventEmitter<boolean>();
  @Output() timeMoment = new EventEmitter<boolean>();
  @Output() showModal = new EventEmitter<boolean>();
  @Output() showSelected = new EventEmitter<boolean>();
  public range: boolean = false;
  public moment: boolean = false;
  public alert : boolean = false;
  public selectedLayers: boolean = true;
  public menuOptions = [
    { name: 'Periodos', id: 'periodos' },
    // { name: 'Campos', id: 'fields' },
    // { name: 'Variables', id: 'sidebar' },
    //{ name: 'Gráficos', id: 'graph' },
  ];

  constructor(public mapService: MapService) {}

  ngOnInit(): void {
    this.showSelected.next(this.selectedLayers);
  }

  setShowMenu(id: string) {
    this.range = !this.range;
    this.moment = !this.moment;
    this.showMenu.next(id);
    this.timeRange.next(this.range);
    this.timeMoment.next(this.moment);
  }
  setShowModal(){
    this.alert=!this.alert
    if(this.selectedLayers){
      this.showSelected.next(false);
    }
    this.showModal.next(this.alert);
  }

  setShowSelected(){
    this.selectedLayers=!this.selectedLayers
    if(this.alert){
      this.showModal.next(false);
    }
    this.showSelected.next(this.selectedLayers);
  }
}
